import React, { useEffect, useState } from 'react';
import AdminHeader from '../Header/AdminHeader'
import AdminLeftMenu from '../Navbar/AdminLeftMenu'
import AdminFooter from '../Footer/AdminFooter'
import { Link, useParams } from 'react-router-dom';
import { userloginDetails } from '../Utils/AdminAuth';
import api from "../../axios/Axios";
import { ADMIN_USERS_LIST } from '../../constants/ServiceConstants';
import Spining from '../UI/Spining/Spining';
import Alert from '../UI/Alert/Alert';
import Axios from '../../axios/Axios';
import { HOST_URL } from '../Dashboard/api/Api';

const MmliteStatus = () => {
    let { id, brandNumber } = useParams();
    const adminAuthDetails = userloginDetails();

    const [isLoading, setIsLoading] = useState(true);
    const [wabaid, setWabaid] = useState('')
    const [userid, setUserid] = useState("")
    const [userToken, setUserToken] = useState("");
    const [error, setError] = useState({
        status: false,
        bgColor: "",
        message: ""
    });
    const [mmliteRequestid, setMMliteRequestid] = useState('');
    const [confirmPopup, setConfirmPopup] = useState(false)

    useEffect(() => {
        getWhatsAppDetails();
    }, []);

    const getWhatsAppDetails = async () => {
        try {
            const { data } = await api.post(ADMIN_USERS_LIST, {
                token: adminAuthDetails.token,
                user_id: adminAuthDetails.user.userId,
                ret_user_id: id,
                brand_number: brandNumber,
                method: "ret_whatsapp_profile",
            });
            if (data.success === true) {
                setWabaid(data.data[0].waba_id)
                setUserid(data.data[0].id)
                setUserToken(data.data[0].token)
                let mmliteStatus = JSON.parse(data.data[0]?.mmlite_status)               
                setMMliteRequestid(mmliteStatus)
                setIsLoading(false);
            } else {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    message: data.message
                })
                setIsLoading(false);
            }
        } catch (err) {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                message: err.message
            })
            setIsLoading(false);
        }
    };

    const SendRequest = async () => {
        try {
            let paramData = {
                user_id: adminAuthDetails.user.userId,
                method: "check_mmlite_status",
                token: adminAuthDetails.token,
                ret_user_id: id,
                id: userid,
                waba_id: wabaid,
                access_token: userToken
            }
            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, paramData)
            if (data.success) {
                setError({
                    status: true,
                    bgColor: "alert alert-success",
                    message: data.message
                });
            }
            else {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    message: data.message
                });
            }
        } catch (error) {
            setError({
                status: true,
                bgColor: "alert alert-danger",
                message: error.message
            });
        }
        finally{
            setConfirmPopup(false)
        }
    }

    return (
        <div>
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                {isLoading && <Spining />}
                                <div className="col-auto d-none d-sm-block">
                                    <h3><strong className='text-dark'>WhatsApp User List</strong></h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title mb-0">
                                            <nav className="text-center" aria-label="breadcrumb">
                                                <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                                                    <Link to={`/admin/whatsapp-account-profile-details/${id}`}><li style={{ fontSize: "13px" }} className="breadcrumb-item">Profile Details</li></Link>
                                                    <Link to={`/admin/whatsapp-account-whatsapp-template-list/${id}`}><li style={{ fontSize: "13px" }} className="breadcrumb-item">Whatsapp Template List</li></Link>
                                                    <Link to={`/admin/whatsapp-account-update-whatsapp-token/${id}`}><li style={{ fontSize: "13px" }} className="breadcrumb-item">Update Whastapp Token</li></Link>
                                                    <Link to={`/admin/whatsapp-account-change-route/${id}`}><li style={{ fontSize: "13px" }} className="breadcrumb-item">Change Route</li></Link>
                                                    <Link to={`/admin/update-waba-id/${id}`}><li style={{ fontSize: "13px" }} className="breadcrumb-item">Update Waba Id</li></Link>
                                                    <Link to={`/admin/mmlite-status/${id}`}><li style={{ fontSize: "13px" }} className="breadcrumb-item active">Check Mmlite Status</li></Link>
                                                    <Link to={`/admin/mmlite-request/${id}`}><li style={{ fontSize: "13px" }} className="breadcrumb-item">Request Mmlite</li></Link>
                                                </ol>
                                            </nav>
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {
                                            error.status ?
                                                <div className={error.bgColor} role="alert">
                                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                    <div className="">
                                                        {error.message}
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }

                                        <div className="form-row ">
                                            <div className="form-group col-md-12">
                                                {wabaid === "" ? <h6 style={{ color: "red" }}>Note: Please Update Your Waba ID First !</h6> : <h6>Waba ID : {wabaid}</h6>}
                                                {wabaid === "" ? null : <p><b>Marketing Message Lite Api Status :</b> {mmliteRequestid?.marketing_messages_lite_api_status} , <b>id :</b> {mmliteRequestid?.id}</p>}
                                            </div>
                                        </div>
                                        {wabaid !== "" &&
                                            <button
                                                onClick={() => setConfirmPopup(true)}
                                                className="btn btn-sm float-right btn-primary"
                                            >
                                                Check MMlite Status
                                            </button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <AdminFooter />
                </div>
            </div>
            {confirmPopup &&
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1050 }}
                >
                    <div className="bg-white rounded shadow p-4" style={{ minWidth: '300px', maxWidth: '90%' }}>
                        <h5 className="mb-3">Confirm Action</h5>
                        <p className="mb-4">Are you sure you want to continue?</p>
                        <div className="d-flex justify-content-end gap-2">
                            <div
                                className="px-3 py-2 bg-danger text-white rounded cursor-pointer mr-2"
                                role="button"
                                onClick={() => setConfirmPopup(false)}
                            >
                                Cancel
                            </div>
                            <div
                                className="px-3 py-2 bg-success text-white rounded cursor-pointer"
                                role="button"
                                onClick={SendRequest}
                            >
                                Confirm
                            </div>
                        </div>
                    </div>
                </div>}
        </div>
    );
};

export default MmliteStatus;